import React from "react";

import TourRunner from "../base/TourRunner";

import { acaActiveDealersTourConfiguration } from "./configuration";

const AcaActiveDealersTour = () => {
  return <TourRunner descriptor={acaActiveDealersTourConfiguration} />;
};

export default AcaActiveDealersTour;
